import axios from 'axios'
import Utils from '@/common/Utils'

const url = process.env.VUE_APP_BLUENV === 'development' ? '/api' : '/api'

const headers = { 'Content-Type': 'application/json' }

export default class UsersBankAccountsService {
    static async getAll (params) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/usersBankAccounts`, { headers, params })
            return Promise.resolve(data)
        } catch (error) {
            return Promise.reject(error)
        }
    }
}
